import React from "react";

export default function WizardInlineHelp({ title = "What is this section for?", children, className = "" }) {
  return (
    <div className={"rounded-xl bg-indigo-500/10 p-3 text-xs text-slate-200/80 ring-1 ring-indigo-400/20 " + className}>
      <div className="font-medium text-indigo-100">{title}</div>
      <div className="mt-1 whitespace-pre-wrap leading-relaxed">{children}</div>
    </div>
  );
}
